var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"haq-onboarding-tooltip-wrap"},[_c('div',{staticClass:"haq-tooltip",class:[_vm.cssPosition, _vm.cssArrowPosition],attrs:{"id":'onboarding-tooltip-' + _vm.id}},[_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))]),_c('div',{staticClass:"btn",on:{"click":_vm.completeTooltip}},[_vm._v("Got it!")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }